import React from "react";
import {
  Area,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  AreaChart as AC,
} from "recharts";
import Card from "../../../Components/Card";
import moment from "moment";
import { toNumericSeries } from "../../../Utils/chartScale";

const AreaChart = ({ data, showDecimalLabel, toolTipValueName }) => {
  // Werte kommen als Strings aus der API (bigint/numeric ueber node-pg). Ohne
  // Umwandlung berechnet Recharts die Y-Domain per Stringvergleich und die
  // Flaeche laeuft oben aus dem Plotbereich heraus.
  //
  // Mit echten Zahlen genuegt die Standard-Domain [0, "auto"] der YAxis: Sie
  // rundet auf einen glatten Wert oberhalb des Maximums auf, sodass die Kurve
  // vollstaendig im Plotbereich liegt und die Ticks lesbar bleiben.
  const chartData = React.useMemo(() => toNumericSeries(data, "value"), [data]);

  return (
    <ResponsiveContainer height={300}>
      <AC
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        syncId="user_analytics"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip
          content={
            <CustomTooltip
              toolTipValueName={toolTipValueName}
              showDecimalLabel={showDecimalLabel}
            />
          }
        />
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#6b21a8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#6b21a8" stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis dataKey="day" />
        <YAxis />
        <Area
          type="monotone"
          dataKey="value"
          stroke="#6b21a8"
          fill="url(#colorUv)"
          dot={{ stroke: "#A87BCC", strokeWidth: 2 }}
          isAnimationActive={false}
        />
      </AC>
    </ResponsiveContainer>
  );
};
const CustomTooltip = ({
  active,
  payload,
  label,
  toolTipValueName,
  showDecimalLabel,
}) => {
  if (active && payload && payload.length) {
    if (showDecimalLabel)
      payload[0].value = parseFloat(payload[0].value).toFixed(2) + " min";
    return (
      <Card>
        <p className="text-xs font-bold mb-2">
          {moment(label).format("ddd, MMMM Do YYYY")}
        </p>
        <p className="text-primary">{`${toolTipValueName} : ${payload[0].value}`}</p>
      </Card>
    );
  }

  return null;
};
const CustomLabel = (props) => {
  const { x, y, value } = props;
  let roundedValue = null;
  if (props.showDecimalLabel) {
    roundedValue = parseFloat(value)?.toFixed(2) + " min";
  } else {
    roundedValue = parseInt(value);
  }

  return (
    <text x={x} y={y} dy={-10} fill="#A87BCC" fontSize={14} textAnchor="middle">
      {roundedValue}
    </text>
  );
};

export default AreaChart;
